import controller from './checkbox.controller'
import template from './checkbox.html'

const CheckboxComponent = {
	bindings: {
		value: '<',
		label: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default CheckboxComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox/checkbox.component.js